 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","anteprimaDDT":"anteprimaDDT","newSegnalazione":"newSegnalazione","schedaSegnalazione":"schedaSegnalazione","listAttivita":"listAttivita","listDocumenti":"listDocumenti","listSegnalazioni":"listSegnalazioni","listUtenti":"listUtenti","schedaStabilimento":"schedaStabilimento","infoStabilimento":"infoStabilimento","newAttivita~newDocumento~newEvacuatore~schedaAttivita~schedaDocumento":"newAttivita~newDocumento~newEvacuatore~schedaAttivita~schedaDocumento","newAttivita":"newAttivita","newDocumento":"newDocumento","newEvacuatore":"newEvacuatore","schedaAttivita":"schedaAttivita","schedaDocumento":"schedaDocumento","newUtente":"newUtente","schedaUtente":"schedaUtente","laMiaScheda":"laMiaScheda","login":"login","homepage":"homepage","stampaAttivita":"stampaAttivita"}[chunkId]||chunkId) + "." + {"about":"9e1ef730","chunk-194bb33a":"a72e699e","anteprimaDDT":"8c7ff474","chunk-441d2498":"07fa20f1","chunk-ff0bfd3e":"dd6a0536","chunk-8e1bdcc6":"89cfa836","chunk-77ab0bec":"324aa6d8","chunk-04f914b6":"c89435a1","newSegnalazione":"7d0f1662","schedaSegnalazione":"180159d0","chunk-2d442710":"0f8e47e4","listAttivita":"e4b83046","listDocumenti":"aa52459d","listSegnalazioni":"25d22320","listUtenti":"4d93f847","chunk-e1fb48cc":"90501546","schedaStabilimento":"f589de07","infoStabilimento":"681c59d8","newAttivita~newDocumento~newEvacuatore~schedaAttivita~schedaDocumento":"842e21e1","newAttivita":"0af9b208","newDocumento":"e741c1d8","newEvacuatore":"37a5f8d8","schedaAttivita":"c651286d","schedaDocumento":"5cc08411","newUtente":"11e93e91","schedaUtente":"60ed03a7","laMiaScheda":"883dbdb4","login":"d4e88ce8","homepage":"9f38e7a1","stampaAttivita":"60542196","chunk-2d0bac5e":"8bcd9256","chunk-5379e1ad":"ea9c96de","chunk-27aea6f4":"b4864009","chunk-3643f4bf":"49ca0698","chunk-6a014cde":"0cdfd613","chunk-1cffa542":"0d9c01a5","chunk-0aa802c4":"d6c26398","chunk-2d2371d2":"f71738c4","chunk-35b32921":"4043ca61","chunk-716d1a71":"0472867e","chunk-09cc8d47":"68bb076a","chunk-890dcf74":"0f94145e","chunk-75c5aa34":"672ef790","chunk-2d0e93dc":"31ec9182","chunk-6e2d94bc":"08a39c60","chunk-1d019e77":"21a07b73","chunk-6a55599e":"b0f9dfa6","chunk-2d0ddc7d":"ab0bc7dc","chunk-edce9f4c":"d104fa3d","chunk-edf7316a":"7359b5b4","chunk-edf77994":"f84fc975","chunk-1a8ad9bf":"53c907a4","chunk-1dcc54d1":"3611b33d","chunk-8bc93b7a":"45885662","chunk-816d5ade":"9666c7e5","chunk-00fb620a":"83cb7cb9","chunk-65f83bca":"1e19f34f","chunk-09eaea98":"6247be17","chunk-9362cb30":"943b275d","chunk-2d216db0":"c91843db"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"anteprimaDDT":1,"chunk-441d2498":1,"chunk-ff0bfd3e":1,"chunk-8e1bdcc6":1,"chunk-77ab0bec":1,"chunk-04f914b6":1,"newSegnalazione":1,"schedaSegnalazione":1,"chunk-2d442710":1,"listAttivita":1,"listDocumenti":1,"listSegnalazioni":1,"listUtenti":1,"chunk-e1fb48cc":1,"schedaStabilimento":1,"infoStabilimento":1,"newAttivita~newDocumento~newEvacuatore~schedaAttivita~schedaDocumento":1,"newAttivita":1,"newDocumento":1,"newEvacuatore":1,"schedaAttivita":1,"schedaDocumento":1,"newUtente":1,"schedaUtente":1,"laMiaScheda":1,"login":1,"stampaAttivita":1,"chunk-5379e1ad":1,"chunk-27aea6f4":1,"chunk-3643f4bf":1,"chunk-6a014cde":1,"chunk-0aa802c4":1,"chunk-35b32921":1,"chunk-716d1a71":1,"chunk-09cc8d47":1,"chunk-890dcf74":1,"chunk-75c5aa34":1,"chunk-6e2d94bc":1,"chunk-1a8ad9bf":1,"chunk-1dcc54d1":1,"chunk-8bc93b7a":1,"chunk-00fb620a":1,"chunk-09eaea98":1,"chunk-9362cb30":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","anteprimaDDT":"anteprimaDDT","newSegnalazione":"newSegnalazione","schedaSegnalazione":"schedaSegnalazione","listAttivita":"listAttivita","listDocumenti":"listDocumenti","listSegnalazioni":"listSegnalazioni","listUtenti":"listUtenti","schedaStabilimento":"schedaStabilimento","infoStabilimento":"infoStabilimento","newAttivita~newDocumento~newEvacuatore~schedaAttivita~schedaDocumento":"newAttivita~newDocumento~newEvacuatore~schedaAttivita~schedaDocumento","newAttivita":"newAttivita","newDocumento":"newDocumento","newEvacuatore":"newEvacuatore","schedaAttivita":"schedaAttivita","schedaDocumento":"schedaDocumento","newUtente":"newUtente","schedaUtente":"schedaUtente","laMiaScheda":"laMiaScheda","login":"login","homepage":"homepage","stampaAttivita":"stampaAttivita"}[chunkId]||chunkId) + "." + {"about":"31d6cfe0","chunk-194bb33a":"31d6cfe0","anteprimaDDT":"84023f92","chunk-441d2498":"364917b6","chunk-ff0bfd3e":"508787c5","chunk-8e1bdcc6":"e4a11156","chunk-77ab0bec":"eca48623","chunk-04f914b6":"8d8518a1","newSegnalazione":"2ba9a9d0","schedaSegnalazione":"2ba9a9d0","chunk-2d442710":"35350a86","listAttivita":"1707b3b0","listDocumenti":"1707b3b0","listSegnalazioni":"1707b3b0","listUtenti":"1707b3b0","chunk-e1fb48cc":"1b50a4f7","schedaStabilimento":"9aaa3196","infoStabilimento":"ad437c3b","newAttivita~newDocumento~newEvacuatore~schedaAttivita~schedaDocumento":"a028b0da","newAttivita":"fd25dc4b","newDocumento":"76a811a3","newEvacuatore":"fd25dc4b","schedaAttivita":"08aab963","schedaDocumento":"76a811a3","newUtente":"2e913318","schedaUtente":"2e913318","laMiaScheda":"bfa464a4","login":"549c2a46","homepage":"31d6cfe0","stampaAttivita":"95549bc3","chunk-2d0bac5e":"31d6cfe0","chunk-5379e1ad":"5fd483c7","chunk-27aea6f4":"95549bc3","chunk-3643f4bf":"95549bc3","chunk-6a014cde":"c7af056b","chunk-1cffa542":"31d6cfe0","chunk-0aa802c4":"ea06345d","chunk-2d2371d2":"31d6cfe0","chunk-35b32921":"62ec942b","chunk-716d1a71":"6330bd5b","chunk-09cc8d47":"287d2902","chunk-890dcf74":"8c3b68be","chunk-75c5aa34":"586a3f3a","chunk-2d0e93dc":"31d6cfe0","chunk-6e2d94bc":"95549bc3","chunk-1d019e77":"31d6cfe0","chunk-6a55599e":"31d6cfe0","chunk-2d0ddc7d":"31d6cfe0","chunk-edce9f4c":"31d6cfe0","chunk-edf7316a":"31d6cfe0","chunk-edf77994":"31d6cfe0","chunk-1a8ad9bf":"89702163","chunk-1dcc54d1":"b6f7b867","chunk-8bc93b7a":"9aaa3196","chunk-816d5ade":"31d6cfe0","chunk-00fb620a":"9d21c0d7","chunk-65f83bca":"31d6cfe0","chunk-09eaea98":"1a7c9caf","chunk-9362cb30":"3b733411","chunk-2d216db0":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
